<template>
  <div class="sidebar" @mouseleave="currentIndex = 7">
    <ul class="sidebar-group">
      <li
        v-for="(item, index) in courseTypeList"
        :key="item.id"
        @mouseenter.stop.prevent="currentIndex = index"
      >
        <span class="courseType" @click="clickType(item)">
          {{ item.name }} <i class="el-icon-arrow-right"></i>
        </span>
      </li>
    </ul>
    <div
      class="content-wrapper"
      v-for="(item, index) in courseTypeList"
      :key="index"
      v-if="currentIndex === index"
    >
      <sidebar-content :typeList="item.sonList"></sidebar-content>
    </div>
  </div>
</template>
<script>
import SidebarContent from "./sidebar-content.vue";
export default {
  data() {
    return {
      currentIndex: 7
    };
  },
  props: {
    courseTypeList: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  components: {
    SidebarContent
  },
  methods: {
    clickType(item) {
      let routeData = this.$router.resolve({
        path: "/CourseClassify",
        query: {
          courseTypeId: item.id,
          currentFirstId: item.id,
          status: 1,
          sourceType: 2,
          isOpen: 1,
          pageNo: 1
        }
      });
      window.open(routeData.href, "_self");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/scss" lang="scss" scoped>
@import "~@/styles/base.scss";
.sidebar {
  position: relative;
  .sidebar-group {
    padding-top: 16px;
    padding-left: 15px;
    width: 240px;
    height: 450px;
    box-sizing: border-box;
    font-size: 16px;
    background-color: $sideBarBgc;
    li:hover {
      background-color: #696f75;
      // background-color: red;
      .courseType {
        color: $navBgc;
      }
    }
    .courseType {
      display: block;
      height: 60px;
      line-height: 60px;
      padding-left: 20px;
      color: $sideBarColor;
      text-align: left;
      font-weight: 500;
      cursor: pointer;
      // &:hover {
      //   color: $navBgc;
      //   background-color: #696F75;
      // }
      .el-icon-arrow-right {
        float: right;
        margin-right: 20px;
        line-height: 60px;
        font-weight: 700;
      }
    }
  }
  .sidebar-content {
    position: absolute;
    z-index: 5000;
    top: 0;
    left: 240px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/components/sidebar.vue